export default __webpack_public_path__ + "static/media/promo_03.51843bbc.jpg";